
define('modules/application/wizard/classes/kits/intrusionDetectionKits',["app",

// Libs
"backbone",

//Classes
"../kits"],

function(app, Backbone, kits) {

  var kitModel = Backbone.Model.extend({

    initialize                        : function() {
      this.fetchProducts();
      this.fetchComponentsPackages();
      window.BticinoS4B.eventAggregator.bind("connectToKit", this.connectItems, this);

      var packages       = this.get("specialVars").packages,
          packagesLength = packages.length,
          maxZoneNumber  = 0,
          j              = 0;

      for(j=0; j<packagesLength; j++)
      {
        if (packages[j].specialVars && packages[j].specialVars.maxZoneNumber)
        {
          maxZoneNumber = packages[j].specialVars.maxZoneNumber;
          break;
        }
      }

      this.set("maxZoneNumber", maxZoneNumber);
    },

    fetchProducts                     : function() {
      var that           = this,
          fetchedKits    = this.get("fetchedKits"),
          packageClassId = this.get("packageClassId");

      this.trigger("products:fetching");

      if(!this.get("isPopulated")) {

        BticinoS4B.Instances.Models.ApplicationModel.getProducts(this.get("packageClassId"), function(data) {
          var products          = data.products;
          var mainProduct       = _.filter(products,function(product)    {return (product.mnemonic===1);})[0];
          var secondaryProducts = _.filter(products,function(product)    {return (product.mnemonic!==1);});

          that.attributes = _.extend(that.attributes, mainProduct);
          that.set("secondaryProducts", secondaryProducts);

          if (products.length>0)
            that.set("isPopulated", true);
          else
            console.log("No products for the given package");
        }, false);
        this.trigger("render:requested");
      }
    },

    fetchComponentsPackages           : function(kit) {
      var that          = this,
          packages      = this.get("specialVars").packages,
          packagesLength= packages.length,
          i             = 0;

      var valorizePackage = function(currentPackage) {
        if (currentPackage.specialVars)
          currentPackage.specialVars = JSON.parse(currentPackage.specialVars);

        packages[i]                = _.extend(packages[i], currentPackage);

        if (packages[i].gotZone)
        {
          packages[i].addToZone  = 1;
          packages[i].generatedId= new Date().getUTCMilliseconds();
        }

        BticinoS4B.Instances.Models.ApplicationModel.getProducts(packages[i].packageClassId, function(data) {
          var mainProduct       = _.filter(data.products,function(product)    {return (product.mnemonic===1);})[0];
          var secondaryProducts = _.filter(data.products,function(product)    {return (product.mnemonic!==1);});

          _.extend(packages[i], mainProduct);
          packages[i].secondaryProducts = secondaryProducts;

        }, false);
      };

      for (i = packagesLength - 1; i >= 0; i--)
        BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(packages[i].packageClassId, valorizePackage, false);

      that.trigger("products:fetched");
    },

    addKit                : function() {
      var added = this.get("added");

      if (!added)
      {
        var kitPackages = this.get("specialVars") ? this.get("specialVars").packages : [];

        var zoneNumberChangedEventHandler  =  function(newZoneNumber) {
          this.addToZone = newZoneNumber;
        };

        var requestRefresh                 = function() {
          this.trigger("render:requested");
        };

        for(var i=0, packagesLength = kitPackages.length; i<packagesLength; i++)
        {
          kitPackages[i].kitsEventAggregator = _.extend({}, Backbone.Events);
          kitPackages[i].kitsEventAggregator.bind("zoneNumber:changed", zoneNumberChangedEventHandler, kitPackages[i]);
          kitPackages[i].kitsEventAggregator.bind("zoneNumber:changed", requestRefresh, this);
          window.BticinoS4B.eventAggregator.trigger(kitPackages[i].name+":addedFromKit", kitPackages[i]);
        }
        this.set("added", true);
        window.BticinoS4B.eventAggregator.trigger("kit:added");
        this.trigger("render:requested");
      }
      // else
      //   this.removeCurrentKit();

      this.trigger("render:requested");
      this.trigger("updateViews");
    },

    updatePackageZone                 : function(selector) {
      var packageNumber   = selector.attr("name").substring(13, selector.attr("name").length),
          zoneNumber      = selector.val(),
          packageToUpdate = this.get("specialVars").packages[packageNumber];

      if (this.get("added"))
      {
        this.removePackageFromZone(packageToUpdate);
        packageToUpdate.addToZone = zoneNumber;
        this.addPackageToZone(packageToUpdate);
      }
      else
        packageToUpdate.addToZone = zoneNumber;
    },

    addPackageToZone                  : function(packageToAdd) {
      packageToAdd.kitsEventAggregator = _.extend({}, Backbone.Events);
      packageToAdd.kitsEventAggregator.bind("zoneNumber:changed", function(newZoneNumber){
        packageToAdd.addToZone = newZoneNumber;
        this.trigger("render:requested");
      }, this);
      window.BticinoS4B.eventAggregator.trigger(packageToAdd.name+":addedFromKit", packageToAdd);
    },

    removePackageFromZone             : function(packageToRemove) {
      var zonePackage = packageToRemove.addToZone;
      window.BticinoS4B.eventAggregator.trigger(packageToRemove.name+":removeKitPackage", packageToRemove);
    },

    connectItems              : function(volumetricProtectionToConnect) {
      var kitPackages     = this.get("specialVars").packages,
          packageToUpdate = _.filter(kitPackages, function(iterablePackage){return iterablePackage.packageClassId===volumetricProtectionToConnect.get("packageClassId");});

      if (packageToUpdate.length>0)
      {
        packageToUpdate[0].generatedId = volumetricProtectionToConnect.get("generatedId");
        packageToUpdate[0].addToZone   = volumetricProtectionToConnect.get("zoneNumber");
      }
    },

    isPossibleToAdd           : function() {
      var kitPackages                    = this.get("specialVars").packages,
          maxZoneNumber                  = 4,
          zonesWithoutOneFreeVProtection = BticinoS4B.Instances.Models.ApplicationModel.get("zonesWithoutOneFreeVProtection") ? BticinoS4B.Instances.Models.ApplicationModel.get("zonesWithoutOneFreeVProtection") : [],
          zonesWithFreeVProtection       = [],
          allZones                       = [],
          isPossibleToAdd                = true;

      for (i = kitPackages.length - 1; i >= 0; i--)
      {
        if (kitPackages[i].specialVars.maxZoneNumber)
        {
          maxZoneNumber = kitPackages[i].specialVars.maxZoneNumber;
          break;
        }
      }

      for (i = 1; i <= maxZoneNumber; i++)
        allZones.push(i);

      for (i = kitPackages.length - 1; i >= 0; i--)
      {
        if (kitPackages[i].addToZone)
        {
          window.BticinoS4B.eventAggregator.trigger("zonesWithoutOneFreeVProtection:check");
          zonesWithoutOneFreeVProtection = BticinoS4B.Instances.Models.ApplicationModel.get("zonesWithoutOneFreeVProtection") ? BticinoS4B.Instances.Models.ApplicationModel.get("zonesWithoutOneFreeVProtection") : [];
          zonesWithFreeVProtection       = _.difference(allZones, zonesWithoutOneFreeVProtection);
          if ($.inArray( Number(kitPackages[i].addToZone), zonesWithFreeVProtection)===-1)
            isPossibleToAdd = false;
        }
      }
      BticinoS4B.Instances.Models.ApplicationModel.set("zonesWithoutOneFreeVProtection", []);
      return isPossibleToAdd;
    }
  });

  var intrusionDetectionKits = _.extend({}, kits, {

    Model: kits.Model.extend({
      defaults : _.extend({
        wizardChoiceId : 425,
        dictionary     : [
          {
            productCode            : "MHKIT8513",
            referenceAccessoryLine : 0,
            packageClassId         : "22102"
          }
        ]
      }, kits.Model.defaults),
      addConstructor                    : function() {
        this.kitModel = kitModel;
      },
      initialize : function() {
        kits.Model.prototype.initialize.apply(this);
        this.addConstructor();
      },
      insertThisKit                     : function(kitCode) {
        var value         = this.findValueFromProductCode(kitCode);
        var finalPackage, dataToReturn = {};

        if (value)
        {
          this.fetchKits();
          dataToReturn.packages = [finalPackage];
          BticinoS4B.Instances.Models.ApplicationModel.set("accessoryLineId", 0);
          window.BticinoS4B.eventAggregator.trigger("accessoryLine:chosen", 0);
          _.filter(this.get("fetchedKits"), function(iterableKit){return iterableKit.get("productCode")===kitCode;})[0].addKit();
        }
      }
    })
  });

  // Required, return the module for AMD compliance
  return intrusionDetectionKits;
});